import { ReactNode } from 'react';
import { InjectedFormProps } from 'redux-form';
import MyWaitroseForm from 'components/MyWaitrose/Form/Form';
import ErrorScrolling from 'components/Forms/utilities/ErrorScrolling';
import { ApiError } from 'constants/errors';

export type FormData = {
  myWaitroseCardNumber?: string;
  waitrose: boolean | string;
  mywaitrose: boolean | string;
  johnlewis: boolean | string;
  johnlewisfinancialservices: boolean | string;
};

type FormFormattedData = {
  myWaitroseCardNumber?: string;
  waitrose: boolean;
  mywaitrose: boolean;
  johnlewis: boolean;
  johnlewisfinancialservices: boolean;
};

interface MyWaitroseFormProps
  extends Pick<InjectedFormProps<FormData>, 'handleSubmit' | 'submitting'> {
  children: ReactNode;
  linkCard?: boolean;
  onResetValidation?: () => void;
  onSubmitAction: (data: FormFormattedData) => Promise<unknown>;
  serverError?: ApiError | null;
  // submitted is passed down from the parent component, but redux-form which sources that there
  // doesn't. At run time, it is undefined. It should be removed?
  submitted: boolean;
}

export const onSubmitActionError = (error: ApiError) => {
  const regex = /^4[0-9][0-9]/;
  if (regex.test((error?.status || 200).toString())) {
    return { myWaitroseCardNumber: error?.response?.body?.message };
  }

  throw error;
};

export const castPreference = (value: boolean | string): boolean => {
  if (typeof value === 'boolean') {
    return value;
  }
  return value === 'true';
};

export const formatData = ({
  myWaitroseCardNumber,
  johnlewis,
  johnlewisfinancialservices,
  waitrose,
  mywaitrose,
}: FormData): FormFormattedData => {
  return {
    myWaitroseCardNumber,
    johnlewis: castPreference(johnlewis),
    johnlewisfinancialservices: castPreference(johnlewisfinancialservices),
    waitrose: castPreference(waitrose),
    mywaitrose: castPreference(mywaitrose),
  };
};

export const getFormSubmitResult = ({
  handleSubmit,
  onSubmitAction,
}: Pick<MyWaitroseFormProps, 'handleSubmit' | 'onSubmitAction' | 'submitted' | 'submitting'>) => {
  return handleSubmit(async (data: FormData) => {
    return onSubmitAction(formatData(data)).catch((error: ApiError) => onSubmitActionError(error));
  });
};

const Form = (props: MyWaitroseFormProps) =>
  ErrorScrolling({
    ...props,
    submitResult: getFormSubmitResult(props),
    errorOrder: ['myWaitroseCardNumber', 'choose-address', 'mywaitrose'],
  })(MyWaitroseForm);

export default Form;
